import OrderDetailsTop from "./order-details-top";
import DeliveryDetails from "./delivery-details";
import OrderItems from "./order-items";
import OrderTotal from "./order-total";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { ProductCheckoutProceedModel } from "../../models/products/product-checkout-proceed-model";
import { Suspense, lazy } from "react";
import AppLoading from "../../components/app-loading/app-loading";
import { useNavigate } from "react-router-dom";
import RouteConstant from "../../constants/route.constants";
import OrderService from "../../services/order/order.service";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { itemCount } from "../../redux/slices/counter";
import { selectedPayment } from "../../redux/slices/payments";
import ProductStorageHelpers from "../../utils/product-local-storage-wrapper";
import { selectedGetway } from "../../redux/slices/getway-link";
import { GetWayLinkModel } from "../../models/getway-link/getway-link-model";
import "./order.scss";
import AuthService from "../../services/autentication/auth.service";
const OrderConfirmDialog = lazy(() => import("./order-details-dialog"));
const PaymentConfirmDialog = lazy(() => import("./payment-details-dialog"));
const PaymentMode = lazy(() => import("../payments/payment-mode"));

const OrderDetails = () => {
  const [cartData, setCartData] = useState<ProductCheckoutProceedModel>();
  const [isConfirmDialog, setIsConfirmDialog] = useState(false);
  const [orderId, setOrderId] = useState(0);
  var navigate = useNavigate();
  const dispatch = useAppDispatch();
  const toast = useRef<any>(null);

  const c = useAppSelector((state) => state.comment);
  const isAdmin = useAppSelector((state) => state.isAdmin);
  const selectedAdminUserId = useAppSelector(
    (state) => state.adminUser.selectedAdminUserId
  );
  const [isExecutive, setisExecutive] = useState<boolean>(false);
  const [PlutusTransactionReferenceID, setPlutusTransactionReferenceID] = useState<number>(0);
  const [rewardRatio, setRewardRatio] = useState<number>(0);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  const [showPaymentSelection, setShowPaymentSelection] = useState(false);
  const [pendingRedeemedPoints, setPendingRedeemedPoints] = useState(0);
  const [paymentMode, setPaymentMode] = useState<any>();

  const showOrderSuccess = () => {
    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Order Created Successfully!",
      life: 3000,
    });
  };

  const showOrderFailedError = (message: string) => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: message,
      life: 3000,
    });
  };

  const GetUserRoleId = () => {
    if (AuthService.isUserLoggedIn()) {
      const localData = localStorage.getItem("user");
      const parsedData = JSON.parse(localData !== null ? localData : "");
      return parsedData.roleID === 4 || parsedData.roleID === 8 ? true : false;
    } else {
      return false;
    }
  };

  const getLoggedInUserId = (): number => {
    if (AuthService.isUserLoggedIn()) {
      const localData = localStorage.getItem("user");
      const parsedData = JSON.parse(localData !== null ? localData : "");
      return parsedData.userID || 0;
    }
    return 0;
  };

  useEffect(() => {
    getOrderedItemsLocal();
    setisExecutive(GetUserRoleId);
  }, []);

  const getOrderedItemsLocal = () => {
    const orderedData: ProductCheckoutProceedModel = ProductStorageHelpers.GetProcessedProductStorage();
    if (orderedData !== null) {
      let total: number = orderedData.totalItemCost + orderedData.totalTax;
      let courierCharges = getTotalCourierCharges();
      orderedData.courierProviderID = getCourierProviderId();
      orderedData.courierCharges = courierCharges
      orderedData.packingCharges = 0;
      orderedData.paymentGatewayCharges = 0;
      setItems(orderedData);
    }
  };

  const setItems = (data: ProductCheckoutProceedModel) => {
    data.grandItemTotal = Math.round(data.grandItemTotal);
    ProductStorageHelpers.SetProcessedProductStorage(data);
    setCartData(data);
  };

  const confirmOrder = (redeemedPoints: number, totalPayable: number) => {
    if (totalPayable > 0) {
      if (cartData) {
        cartData.rewardPointsUsed = redeemedPoints;
        cartData.rewardToCurrencyRatio = rewardRatio;
        ProductStorageHelpers.SetProcessedProductStorage(cartData);
        localStorage.setItem("pending-points-used", redeemedPoints.toString());
        localStorage.setItem("pending-reward-ratio", rewardRatio.toString());
        navigate(RouteConstant.payment);
      }
    } else {
      if (cartData) {
        const isRewardOrder = redeemedPoints > 0 && totalPayable === 0;
        cartData.paymentOption = {
          id: isRewardOrder ? "10" : "1",
          mode: isRewardOrder ? "Reward" : "Cash On Delivery",
          code: isRewardOrder ? "Reward" : "COD",
          status: isRewardOrder ? "Reward" : "Cash On Delivery",
          description: isRewardOrder ? "Reward" : "Cash On Delivery",
          dateTime: Date.now().toString()
        };
      }
      deleteLocalStorageData();
      saveCustomerOrder(redeemedPoints);
    }
  };

  const updateItem = () => {
    navigate(RouteConstant.basket);
  };

  const saveCustomerOrder = async (redeemedPoints: number) => {
    if (isPlacingOrder) return;
    setIsPlacingOrder(true);
    try {
      cartData!.comment = c;
      if (cartData !== undefined) {
       const finalPayload = {
          ...cartData,
          comment: c,
          rewardPointsUsed: redeemedPoints,
          rewardToCurrencyRatio: rewardRatio
        };
        let response;
        if (isAdmin || isExecutive) {
          response = await OrderService.setOrderForCustomer(
            finalPayload,
            selectedAdminUserId
          );
        } else {
          response = await OrderService.setOrderFromCustomer(finalPayload);
        }
        if (response.isSuccess) {
          setOrderId(response.id);
          setPlutusTransactionReferenceID(response.plutusTransactionReferenceID);
          if (
            cartData.paymentOption.mode === "Cash On Delivery" ||
            cartData.paymentOption.mode === "Payment Link" ||
            cartData.paymentOption.mode === "Card" ||
            cartData.paymentOption.mode === "UPI" ||
            response.paymentAmount <= 0
          ) {
            setIsConfirmDialog(true);
            setPlutusTransactionReferenceID(response.plutusTransactionReferenceID);
            cartData.plutusTransactionReferenceId = response.plutusTransactionReferenceID;
            cartData.amount = response.paymentAmount;
            cartData.rewardPointsUsed = redeemedPoints;
            cartData.rewardToCurrencyRatio = rewardRatio;
          } else if (cartData.paymentOption.mode === "Online Payment" && response.paymentAmount > 0) {
            const getwayData = response.additionalInfo;
            dispatch(selectedGetway(mapAdditionalInfo(getwayData)));
            showGetwayPage();
          }
          showOrderSuccess();
        } else {
          showOrderFailedError(response.message);
          setTimeout(() => {
            navigate(RouteConstant.products);
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Failed to save customer order:", error);
    } finally {
      setIsPlacingOrder(false);
    }
  };

  const mapAdditionalInfo = (data: any): GetWayLinkModel => {
    return {
      paymentURL: data.paymentURL,
      expectedDeliveryDate: data.expectedDeliveryDate,
    };
  };

  const getTotalCourierCharges = (): number => {
    const serializedCharges = localStorage.getItem("courier-charges");
    let totalCourierCharges = 0;
    if (serializedCharges !== null) {
      totalCourierCharges = JSON.parse(serializedCharges!.toString());
    }
    return totalCourierCharges;
  }

  const getCourierProviderId = (): number => {
    const courierData = localStorage.getItem("courier-provider");
    let providerId = 0;
    if (courierData !== null) {
      const parsedData = JSON.parse(courierData);
      providerId = parsedData.courierProviderID;
    }
    return providerId;
  };

  const deleteLocalStorageData = () => {
    ProductStorageHelpers.ClearAllLocalStorage();
    localStorage.removeItem("processed-items");
    localStorage.removeItem("checkout-items");
    localStorage.removeItem("courier-provider");
    localStorage.removeItem("courier-charges");
    localStorage.removeItem("total-weight");
    dispatch(itemCount(0));
    dispatch(selectedPayment(null));
  };

  const hideConfirmDialog = () => {
    setIsConfirmDialog(false);
    navigate(RouteConstant.products);
  };

  const showGetwayPage = () => {
    setIsConfirmDialog(false);
    navigate(RouteConstant.getwayProcess);
  };

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} />
        <div className="flex flex-column  border-1  surface-border box-shadow-none">
          {cartData ? (
            <>
              <OrderDetailsTop />
              <DeliveryDetails
                address={cartData?.address}
                paymentOption={cartData?.paymentOption}
              />
              <OrderItems cartItemDetails={cartData?.items} />
              <OrderTotal
                userId={selectedAdminUserId || getLoggedInUserId()}
                totalItemCost={cartData.totalItemCost}
                totalTax={cartData.totalTax}
                deliveryHandlingCharges={cartData.deliveryHandlingCharges}
                grandItemTotal={cartData.grandItemTotal}
                confirmOrder={confirmOrder}
                updateItem={updateItem}
                paymentMode={cartData.paymentOption.mode}
                comment={cartData.comment}
                courierCharges={cartData.courierCharges}
                packingCharges={cartData.packingCharges}
                paymentGatewayCharges={cartData.paymentGatewayCharges}
                setRewardRatio={setRewardRatio}
                isPlacingOrder={isPlacingOrder}
              />
            </>
          ) : null}
        </div>
        {(cartData?.paymentOption.mode === "Card" || cartData?.paymentOption.mode === "UPI") && (cartData?.amount || 0) > 0 ?
          (<PaymentConfirmDialog
            showConfirmDialog={isConfirmDialog}
            hideConfirmDialog={hideConfirmDialog}
            orderId={orderId}
            PlutusTransactionReferenceId={PlutusTransactionReferenceID}
            orderDetails={cartData}
            paymentModeType={cartData?.paymentOption.mode}
            amount={cartData.amount}
          />) :
          cartData ? (
            <OrderConfirmDialog
              showConfirmDialog={isConfirmDialog}
              hideConfirmDialog={hideConfirmDialog}
              orderDetails={cartData}
              orderId={orderId}
              showGetwayPage={showGetwayPage}
            />
          ) : null
        }
      </Suspense>
    </>
  );
};

export default OrderDetails;
